// Gomme kodu ek bir web chat kanalini gosteriyorsa iframe adresi ?channel=<id> tasir
const match = /[?&]channel=([a-f0-9]{24})(&|$)/i.exec(window.location.search || "");

export const getChannelId = () => (match ? match[1] : null);



// WEBPACK FOOTER //
// ./src/utils/channel.js